enum AllocationPublicHolidayFormNames {
  DetailsName = 'details',
  DetailsLabel = 'Details',
  DataName = 'date',
  DateLabel = 'Date'
}

export default AllocationPublicHolidayFormNames;
